import image from './content-sets/image';
import backgroundWheel from './content-sets/background-wheel';
import searchDrivers from './content-sets/search_drivers';

export default function () {
  image();
  backgroundWheel();
  searchDrivers();
}
